module.exports = __webpack_public_path__ + "style/img/Group 1754.d6b8a357.png";